import { z } from "zod";
import env from "@/app/config/env";

export const NotificationSubscriptionAssignItemSchema = z
  .object({
    ProductId: z.string(),
    ProductName: z.string(),
    ProductImage: z
      .string()
      .transform((value) => (value ? `${env.hosts.image}/${value}` : ``)),
    ProductNumber: z.string(),
    SubscriptionId: z.string(),
    Manageable: z.boolean(),
    FreeLicenses: z.number(),
  })
  .transform((data) => ({
    ...data,
    UrlMSD: data.SubscriptionId
      ? `https://petrosoftincstage.crm.dynamics.com/main.aspx?pagetype=entityrecord&etn=new_customlineitem&id=${data.SubscriptionId}`
      : ``,
  }));

export type NotificationSubscriptionAssignItemType = z.infer<
  typeof NotificationSubscriptionAssignItemSchema
>;
